/**
 * Forces a full-document navigation to `/auth` instead of a client-side
 * (in-bundle) redirect. CloudFront's reverse proxy routes `/auth*` to the
 * migrated Next.js app, but that routing is only consulted on a real browser
 * navigation. A client-side `<Redirect>` or `window.location.reload()` keeps
 * the already-loaded legacy bundle in control and never reaches CloudFront, so
 * the user ends up back on the legacy sign-in. See CUX-698.
 */

/**
 * Normalises a `location.search` value into a query string ready to append to a
 * path: empty when there is nothing to carry, otherwise prefixed with `?`.
 */
function normalizeSearch(search: string): string {
    if (!search || search === '?') return '';
    return search.startsWith('?') ? search : `?${search}`;
}

/**
 * Builds the `/auth` URL, preserving the current query string.
 */
export function buildAuthUrl(search: string): string {
    return `/auth${normalizeSearch(search)}`;
}

/**
 * Performs a full-document navigation to `/auth`, preserving the query string.
 *
 * Uses `replace` so no back-button entry is kept — the caller (logout, logged-out
 * route guards) is redirecting away from a page the user should not return to.
 */
export function redirectToAuth(): void {
    window.location.replace(buildAuthUrl(window.location.search));
}
